var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-cascader',_vm._g(_vm._b({attrs:{"options":_vm.options,"show-search":{ filter: _vm.filter },"placeholder":"请选择省市区"}},'a-cascader',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }